import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useProgress from 'src/hook/data/useProgress';
import { useToast } from 'src/hook/global/useToasts';
import usePopUp from 'src/hook/modal/usePopUp';
import { UserFields } from 'src/model/enum/dataEnums';
import styles from './BirthYearModal.module.scss';



const BirthYearModal = () => {
    const [year, setYear] = useState('');
    const isValid = /^\d{4}$/.test(year);
    const { hide } = usePopUp();
    const { t } = useTranslation();
    const toast = useToast();
    const { updateUserInfoField } = useProgress();

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setYear(e.target.value.replace(/[^\d]/g, ''));
    };

    const handleSave = () => {
        if (isValid) {
            updateUserInfoField(UserFields.BirthYear, year);
            toast.showSuccess(t('Birth Year saved'));
            hide();
        }
    };

    return (
        <div className={styles.birthYearModal}>
            <label className={styles.label} htmlFor="birthYearInput">{t('Birth Year')}</label>
            <input
                id="birthYearInput"
                className={styles.input}
                type="text"
                maxLength={4}
                placeholder={t('Year of Birth... (e.g. 1990)')}
                value={year}
                onChange={handleChange}
            />
            <button
                className={styles.saveBtn}
                onClick={handleSave}
                disabled={!isValid}
            >
                {t('Save')}
            </button>
        </div>
    );
};

export default BirthYearModal;
